import types from './types';
import actions from './actions';
import { ValueOf } from 'sl-api-connector/types';

const omniCategories = (state = [], action: ReturnType<ValueOf<typeof actions>>) => {
  switch (action.type) {
    case types.RECEIVE_ALL_OMNI_CATEGORIES:
      return Object.assign([], action.categories);
    default:
      return state;
  }
};

export default omniCategories;
